<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col cols="7" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista de Usuários</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in userList" :key="index" class="d-flex px-3 align-items-center">
                    <d-col cols class="text-fiord-blue pl-0">
                        {{ row.name }}
                    </d-col>
                    <d-col cols class="text-fiord-blue pl-0">
                      {{ row.email }}
                    </d-col>
                    <d-col cols="auto">
                      <d-select v-model="row.settings.role_id" @change="setRole(row)">
                        <option value="">Selecione um departamento</option>
                        <option :value="option.id" v-for="(option, index) in rolesList" :key="index">{{ option.name }}</option>
                      </d-select>
                    </d-col>
                  </d-list-group-item>
                  <d-list-group-item v-if="userList.length == 0">
                    <h5 class="no-content">Nenhum usuário cadastrado ainda.</h5>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import AccessControlService from '_services/rest/modules/accessControl';
import formatErrors from '_common/mixins/FormatErrors';
import { OPTION } from '../SettingsModel';

export default {
  name: 'users-form',
  mixins: [formatErrors],
  components: {
  },
  data() {
    return {
      userList: [],
      role: null,
    };
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    getUsers() {
      AccessControlService.getUsers()
        .then(response => { this.userList = response; });
    },
    setRole(user) {
      setTimeout(() => {
        AccessControlService.setRole(user)
          .then(() => this.activeAlert({ message: 'Departamento alterado com sucesso', theme: 'success' }))
          .catch(this.showError);
      }, 5);
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
